/**
 * Hydrates the header quote-cart count bubble from localStorage and keeps it
 * in sync with `quote-cart:change` events. Server can't render the count
 * (it lives in the browser), so the bubble starts hidden and is revealed
 * here once a count is known.
 */
if (!customElements.get('quote-icon-bubble')) {
  customElements.define(
    'quote-icon-bubble',
    class QuoteIconBubble extends HTMLElement {
      connectedCallback() {
        this.bubble = this.querySelector('[data-quote-count-bubble]');
        this.countEl = this.querySelector('[data-quote-count]');
        this.labelEl = this.querySelector('[data-quote-count-label]');

        this.update();
        this.changeUnsubscriber = this.subscribe();
      }

      disconnectedCallback() {
        this.changeUnsubscriber?.();
      }

      subscribe() {
        const handler = () => this.update();
        window.addEventListener('quote-cart:change', handler);
        // QuoteCart stores in localStorage, so updates from another tab on
        // the same origin should also reflect in this tab's badge.
        window.addEventListener('storage', (event) => {
          if (event.key === window.QuoteCart?.STORAGE_KEY) this.update();
        });
        return () => window.removeEventListener('quote-cart:change', handler);
      }

      update() {
        const count = window.QuoteCart?.count() ?? 0;
        if (!this.bubble || !this.countEl) return;

        if (count <= 0) {
          this.bubble.hidden = true;
          return;
        }
        this.bubble.hidden = false;
        this.countEl.textContent = count < 100 ? String(count) : '99+';
        if (this.labelEl) {
          this.labelEl.textContent = `${count} ${count === 1 ? 'item' : 'items'} in quote`;
        }
      }
    }
  );
}
